import axios from "utils/publicAxios";

export const getRatingStatus = (key) => {
  return axios.get(`/WA/ratings/status/${key}`);
};

export const createRating = (payload) => {
  return axios.post(`/WA/ratings`, payload);
};

export const updateRating = ({ id, ...payload }) => {
  return axios.put(`/WA/ratings/${id}/message`, payload); // di cek lagi di docs takutnya ada perubahan
};
